import { render } from "@/components/pages/individualWorkSupport/requirement053/Requirement053.html?vue&type=template&id=49a397dd&scoped=true&external"
import script from "@/components/pages/individualWorkSupport/requirement053/Requirement053.js?vue&type=script&lang=js&external"
export * from "@/components/pages/individualWorkSupport/requirement053/Requirement053.js?vue&type=script&lang=js&external"

import "@/components/pages/individualWorkSupport/requirement053/Requirement053.scss?vue&type=style&index=0&id=49a397dd&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49a397dd"]])

export default __exports__